import { twMerge } from "tailwind-merge";

interface StatisticCardProps {
    number?: string;
    text?: string;
    numberColor?: string;
}

export default function StatisticCard({
    number,
    text,
    numberColor,
}: StatisticCardProps) {
    return (
        <>
            <div className=" flex-col justify-start items-start gap-2 inline-flex">
                <div className="justify-start items-baseline gap-1 inline-flex">
                    <div
                        className={twMerge(
                            "text-[80px] font-bold font-['Avenir Next Condensed'] leading-[88px]",
                            numberColor,
                        )}
                    >
                        {number}
                    </div>
                    <div
                        className={twMerge(
                            "text-[40px] font-bold font-['Avenir Next Condensed'] uppercase leading-10",
                            numberColor,
                        )}
                    >
                        %
                    </div>
                </div>
                <div className="self-stretch text-black text-xl1 font-normal leading-8.5">
                    {text}
                </div>
            </div>
        </>
    );
}
